import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Home from './pages/Home';
import Login from './pages/Login';
import Chat from './pages/Chat';
import Profile from './pages/Profile';
import Search from './pages/Search';
import Details from './pages/Details';
import Admin from './pages/Admin';
import ClubManagement from './pages/ClubManagement';

const App: React.FC = () => {
    const isAuthenticated = (): boolean => {
        return !!localStorage.getItem('token');
    };

    const isAdmin = (): boolean => {
        const userStr = localStorage.getItem('user');
        if (!userStr) return false;
        
        try {
            const user = JSON.parse(userStr);
            return user.role === 'admin';
        } catch {
            return false;
        }
    };
    const isClubLeader = (): boolean => {
        const userStr = localStorage.getItem('user');
        if (!userStr) return false;
        try {
            const user = JSON.parse(userStr);
            return user.role === 'club_leader' || user.role === 'admin';
        } catch {
            return false;
        }
    };
    
    return (
        <Router>
            <Toaster 
                position="top-right"
                toastOptions={{
                    duration: 4000,
                    style: {
                        background: '#363636',
                        color: '#fff',
                    },
                }}
            />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/chat" element={isAuthenticated() ? <Chat /> : <Navigate to="/login" />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/profile/:id" element={<Profile />} />
                <Route path="/search" element={<Search />} />
                <Route path="/search/:criteria" element={<Search />} />
                <Route path="/details/:id" element={<Details />} />
                <Route path="/admin" element={isAuthenticated() && isAdmin() ? <Admin /> : <Navigate to="/" />} />
                <Route path="*" element={<Navigate to="/" />} />
                <Route path="/clubs" element={isAuthenticated() && isClubLeader() ? <ClubManagement /> : <Navigate to="/" />} />
            </Routes>
        </Router>
    );
};

export default App;
